import { deviceType } from './deviceTypeEnum';
import { gender } from './genderEnum';
import { status } from './statusEnum';
import { userType } from './userTypeEnum';
import { contractorStatus } from './contractorStatusEnum';
import { supplierStatus } from './supplierStatus';
import { accessMethod } from './accessMethodEnum';
import {
    IDENTITY_VALIDATION_TYPE_TRANS
} from "../pages/Dashboard/Visitor/Visitor/Model/Model";
import {DishCategoryPayload, MealType, } from '../pages/Dashboard/Dining/Menu/Model/Model';
import { MEAL_CATEGORY } from '../pages/Dashboard/Dining/Manage/Models/Model';
import {
    MATERIAL_CONTROL_TYPE_TRANS,
    MOVEMENT_DIRECTION_TRANS,
    VEHICLE_MOVEMENT_REASON_TRANS
} from '../pages/Dashboard/MaterialControl/Model/Model';

export const fieldNameEnum = {
    deviceType,
    gender,
    status,
    approvalStatus: status,
    visitorStatus: status,
    userType,
    contractorStatus,
    supplierStatus,
    entryAccessMethod: accessMethod,
    exitAccessMethod: accessMethod,
    accessMethod,
    identityValidation: status,
    identityValidationType: IDENTITY_VALIDATION_TYPE_TRANS,
    foodieMealType: MealType,
    foodieCourseType: DishCategoryPayload,
    isExtraRequest: MEAL_CATEGORY,
    // Material control: the service sends these values as the text it stores
    type: MATERIAL_CONTROL_TYPE_TRANS,
    movementDirection: MOVEMENT_DIRECTION_TRANS,
    movementReason: VEHICLE_MOVEMENT_REASON_TRANS,

};
